import {openDB, idb} from 'idb';

import ServiceDataResponse from '../models/ServiceDataResponse';
import ServiceResponse from '../models/ServiceResponse';

const DB_NAME = "obsSusDb";
const DEFAULT_OBJECT_STORE = "obsSuspended";

// indexes e.g. {field: "offlineId", name: "offlineId", unique: true}
export default class LocalQueuedDbService
{
    constructor()
    {
        this.defaultObjectStore = DEFAULT_OBJECT_STORE;
        this.dbName = DB_NAME;
        this.indexes = [
            {field: "suspendTag", name: "suspendTag", unique: true}
        ]
        this.idb = {
            db: openDB(DB_NAME, 1,{  
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    switch(oldVersion)
                    {
                        case 0:
                            
                             const store = db.createObjectStore(DEFAULT_OBJECT_STORE) 
                             if (this.indexes)
                             {
                                this.indexes.forEach((i) => {
                                    store.createIndex(i.field, i.name, {unique: i.unique} )
                                })
                             }
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }

    async fetchAllSuspendedTags()
    {
        try
        {
            var result = await (await this.idb.db).getAllKeys(DEFAULT_OBJECT_STORE);
            return ServiceDataResponse.toServiceDataResponse(result, "All Suspended Observation Keys Fetched Successfully.", false)
        } 
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching All Suspended Observation Keys. ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async hasSuspendedObservations()
    {
        var suspendedTagsResponse = await this.fetchAllSuspendedTags();
        // TBD - how handle error?
        return (suspendedTagsResponse.data.length > 0);
    }


    async addObservation(gcid, suspendedObservation, suspendTag)
    {
        try
        {
            (await this.idb.db).add(DEFAULT_OBJECT_STORE, suspendedObservation, suspendTag);
            return ServiceResponse.toServiceResponse("Suspended Observation added", false);
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem adding Suspended Observation.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }

    }

    async fetchObservation(gcid, suspendTag)
    {
        try
        {
            var resultData = await (await this.idb.db).get(DEFAULT_OBJECT_STORE, suspendTag);
            return ServiceDataResponse.toServiceDataResponse(resultData, "Observation " + suspendTag + " fetched.", false);
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching Suspended Observation by id " + suspendTag + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async fetchAllObservations()
    {
        try
        {
            var resultData = await (await this.idb.db).getAll(DEFAULT_OBJECT_STORE);
            var result = resultData.map(offlineRec =>{
                console.log("offlineRec:");
                console.log(offlineRec);
                var res = JSON.parse(offlineRec.ObservationSnapshot);
                // add offline status fields
                res.identifiers = {id: offlineRec.Offline.id, gcid: offlineRec.Gcid, status: offlineRec.Offline.uploadStatus, statusReason: ""} ;
                return res;
            }) ;
            return ServiceDataResponse.toServiceDataResponse(result, "All Suspended Observations Fetched Successfully.", false)
        } 
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching All Suspended Observations. ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }


    async deleteObservation(suspendTag)
    {
        try
        {
            var result = await (await this.idb.db).delete(DEFAULT_OBJECT_STORE, suspendTag);   
            return ServiceResponse.toServiceResponse("Suspended observation " + suspendTag + " removed successfully.", false); 
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem removing Suspended Observation " + suspendTag + ". ", true);
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }



}



